import { createSelector } from 'reselect';

export const getCompradores = (state) => state.compradores;

export const getPessoaFisica = createSelector(
  getCompradores,
  (state) => !!state.pessoaFisica
);
